<script>

import ViewTransferDetails from "../modals/ViewTransfer.vue";
export default {
    name: "TransfersTab",

    data() {

        return {
            filter: {
                status: 1,
                from: this.$moment().startOf('month').format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                storeId:0,
            },
            transfers: [],
             currentTransfer: {}, 
             transferdetails: [], 
            view: false,
           decline:false,
           Stores:[],
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchTransfers(),this.fetchMyStores(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchTransfers() {

           
            let url = ``;
            switch (this.filter.status) {
                case 1:
                    url = `StockTransfer/GetPendingStockTransftersfilterDate`;
                    break;
                case 2:
                    url = `StockTransfer/GetApprovedStockTransftersfilterDate`;
                    break;
                case 3:
                    url = `StockTransfer/GetDeclinedStockTransftersfilterDate`;
                    break;
                default:
                    url = `StockTransfer/GetPendingStockTransftersfilterDate`;
                    break;
            }

            url += `?Datefrom=${this.filter.from}`;
            url += `&Dateto=${this.filter.to}`;
            url += `&StoreId=${this.filter.storeId}`;

            return this.$http.get(url).then(({ data }) => {
             //   this.orders = data.map(order => ({...order, view: false, }));
           this.transfers = data;
            }).catch(() => {});
        },
        fetchTransferDetails(refNo) {
            let url = `StockTransfer/ApprovedStockTranferItems`;
                url += `?TransferCode=${refNo}`;
             url += `&UserName=${this.$root.username}`;
            
            return this.$http.get(url).then(({ data }) => {
                this.transferdetails = data;
            }).catch(() => {});
        },
        fetchMyStores() {
            let url = `Shared/GetStorageLocationsForUser`;
                url += `?UserName=${this.$root.username}`;

            return this.$http.get(url).then(({ data }) => {
                this.Stores = data;
            }).catch(() => {});
        },
    },
    
    components: {

        'view-transfer-details': ViewTransferDetails 
    },
}
</script>
<template>
<div class="w-full flex flex-wrap items-center">
    <div class="w-full flex flex-wrap">
        <div class="md:w-1/6 w-1/2 p-1">
            <label for="grid-filter" class="label-control">Status</label>
            <tail-select>
                <template v-slot:field>
                    <select id="grid-filter" 
                        v-model="filter.status"
                        class="input-control input-sm text-xs">
                        <option :value="1">Pending</option>
                        <option :value="2">Approved</option>
                        <option :value="3">Declined</option> 
                    </select>
                </template>
            </tail-select>
        </div>
        
         <div class="md:w-1/6 w-1/2 p-1">
            <label for="grid-filter" class="label-control">Receiving Store</label>
            <tail-select>
                                <template v-slot:field>
                                    <select id="grid-store-from" 
                                        v-model="filter.storeId"
                                        class="input-control input-sm text-xs">
                                        <option :value="0">Select Store From</option>
                                        <option v-for="store in Stores" 
                                            :key="store.id" :value="store.id">{{ store.name }}</option>
                                    </select>
                                </template>
                            </tail-select>
        </div> <div class="md:w-1/4 w-1/2 p-1">
            <label for="grid-filter-from" class="label-control">From</label>
            <input type="date" id="grid-filter-from" 
                v-model.trim="filter.from"
                class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/4 w-1/2 p-1">
            <label for="grid-filter-to" class="label-control">To</label>
            <input type="date" id="grid-filter-to" 
                v-model.trim="filter.to"
                class="input-control input-sm text-xs">
        </div>
        <div class="md:w-1/6 w-1/2 p-1">
            <button 
            @click.prevent="() => {
                $root.loading = true;
                fetchTransfers().then(() => {
                    $root.loading = false;
                });
            }"
            class="btn-sm btn-primary text-xs rounded mt-5">
                <i class="fa fa-filter"></i> Filter
            </button>
        </div>
    </div>
    <div class="w-full overflow-auto">
        <table class="table">
            <thead class="bg-blue-500 text-white text-xs">
                <tr class="flex w-full">
                    <th class="p-tiny flex-1">Ref</th>
                  
                    <th class="p-tiny flex-1">Request Details</th>
                    <th class="p-tiny w-1/6">Status</th>
                    <!-- <th class="p-tiny flex-1">Department</th> -->
                    <th class="p-tiny flex-1">Store Details</th>
                    <th class="p-tiny flex-1">Approval Details</th>
                    <th class="p-tiny flex-1">Approval Memo</th>
                    <th class="p-tiny flex-1">Action</th>
                </tr>
            </thead>
            <tbody
                class="flex flex-col items-center text-xs bg-gray-200 overflow-auto h-30">
                <tr 
                    v-for="(transfer, idx) in transfers" :key="idx"
                    class="flex w-full">
                    <td class="p-tiny flex-1">{{ transfer.transferCode}}</td>
                    
                    <td class="p-tiny flex-1">
                        <h5 class="text-xs">Request On: {{ transfer.date | dateFormat }}</h5>
                        <h5 class="text-xs">User: {{ transfer.userName }}</h5>
                    </td>
                    <td class="p-tiny w-1/6 break-words">
                        <h5 class="text-xs" v-if="transfer.approved">Approved</h5>
                        <h5 class="text-xs" v-else-if="transfer.declined">Declined</h5>
                        <h5 class="text-xs" v-else>Not Approved</h5>
                       
                    </td>
                    <!-- <td class="p-tiny flex-1">
                        -
                    </td> -->
                    <td class="p-tiny flex-1">
                        <h5 class="text-xs">
                            Receiving Store: {{ transfer.storeTo }}</h5>
                        <h5 class="text-xs">
                            Order From: {{ transfer.storeFrom }}</h5>
                    </td>  <td class="p-tiny flex-1">
                        <h5 class="text-xs">
                            Approval Date: {{ transfer.dateApproved| dateFormat }}</h5>
                        <h5 class="text-xs">
                            Approved By: {{ transfer.approvedby }}</h5>
                    </td>
                  <td class="p-tiny flex-1">{{ transfer.approvalMemo?transfer.approvalMemo:'-'}}</td>
                    
                    <td class="p-tiny flex-1">
                         <button v-if="(transfer.approved||transfer.declined)"
                            @click.prevent="() => {
                                currentTransfer = transfer;
                                fetchTransferDetails(transfer.transferCode).then(() => {
                                     view = true;
                                })
                            }"
                            class="btn-sm btn-primary text-xs rounded mr-1">
                                View</button>
                                  <button
                            v-if="$root.checkAuth(`ApproveInventoryOrders`) && (!transfer.approved||transfer.declined)"
                            @click.prevent="$router.push({ 
                                name: ``, query: { initiateTR: 1, 
                                    transfercode: transfer.transferCode, approval: 1, }
                            }).catch(()=>{})"
                            class="btn-sm btn-info text-xs rounded">
                                Approve/Decline</button>
                                   <view-transfer-details 
        :showModal="view"
        :transferdetails="currentTransfer"
        :order="currentTransfer"
        :decline="false"
         :transferedItems="transferdetails"
        
        @closeModal="() => {
            view = false;
         currentTransfer = {};
             
        }"
        
    />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>
